import DocViewer, { PDFRenderer, PNGRenderer } from "@cyntler/react-doc-viewer";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PDF from "./IAGI.pdf";
import PDF2 from "./IAGI2.pdf";
import $ from "jquery";
import Swal from "sweetalert2";
import { useState } from "react";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import { AddApplication } from "../../../Redux/Reducers/Shared/ApplicationInformation";

const TermsAndAddApplication = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.languageReducer.Language);

  const [canClick, setCanClick] = useState(true);

  const state = useSelector((state) => {
    return {
      ApplicationInformation: state.ApplicationInformation,
      jsonData: state.FetchDataJson,
    };
  });
  const [activeDocument, setActiveDocument] = useState(
    lang != "en" ? PDF : PDF2
  );



 
  const addNewApplication = async () => {
    if (canClick) {
      setCanClick(false);
      const addapp = await dispatch(AddApplication());
      console.log(addapp, "addapp");
      
      if (addapp.payload) {
        setCanClick(true);

        if (addapp.payload?.length == 0) {
          Swal.fire({
            title: "لايوجد دورة فعالة",
            icon: "info",
            confirmButtonText: "خروج",
            cancelButtonText: "الغاء",
            showCancelButton: false,
            showCloseButton: true,
          }).then((res) => {
            if (res.isConfirmed) {
              window.location.replace("/ResearchersAward/mainpage");
            }
          });
        } else {
          localStorage.setItem("ApplicationInformationId", addapp.payload);
          navigate("/ResearchersAward/ApplicationInformation");
        }
      }
    }
  };

  return (
    <div className={`AgreeTerms`}>
      {!state.ApplicationInformation?.loadingApplicationInformation ? (
        <div>
          <div className="DocViewerContainer">
            <DocViewer
              className="DocViewer"
              documents={[{ uri: activeDocument }]}
              pluginRenderers={[PDFRenderer, PNGRenderer]}
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                },
              }}
            />
          </div>

          <div className="ContainerButtonApproved">
            <div className="SectionBTN">
              <ButtonAHSF
                fieldsName="approve"
                show={true}
                lang={lang}
                type="submitter"
                onClick={() => {
                  addNewApplication();
                }}
              />

              <ButtonAHSF
                fieldsName="Disapprove"
                show={true}
                lang={lang}
                type="submitter"
                onClick={() => {
                  $(".close-btn").trigger("click");
                }}
              />
            </div>
          </div>
        </div>
      ) : null}
      <LoaderAHSF show={!canClick} />
    </div>
  );
};

export default TermsAndAddApplication;
